<li class="breadcrumb-item">
  <evc-button
    class="breadcrumb-item__button"
    [class.breadcrumb-item__button--current]="current()"
    type="neutral"
    frame="none"
    [routerLink]="link()"
    [disabled]="disable() || current()"
    (click)="onClick()">
    @if (homeIcon()) {
      <evc-icon
        class="breadcrumb-item__home"
        [size]="size()"
        svgPath="assets/ims-icons/home-ims.svg" />
    }
    <ng-content />
  </evc-button>

  @if (!current()) {
    <evc-icon
      class="breadcrumb-item__icon"
      [size]="size()"
      icon="chevron-right" />
  }
</li>
